export default __webpack_public_path__ + "static/media/phoneBlue.64ee8b0d.svg";